module.exports = __webpack_public_path__ + "static/media/ad-suggested.aaf7c51d.png";